'use strict';

var isBrowser = require('../is-browser.cjs');
var state = require('./state.cjs');

function initPrefersReducedMotion() {
    state.hasReducedMotionListener.current = true;
    if (!isBrowser.isBrowser)
        return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = () => (state.prefersReducedMotion.current = motionMediaQuery.matches);
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    }
    else {
        state.prefersReducedMotion.current = false;
    }
}

exports.initPrefersReducedMotion = initPrefersReducedMotion;
//# sourceMappingURL=index.cjs.map
